import { useAccountDetails } from '@api/hooks/useAccounts';
import { toastError } from '@components/Toast/Toast';
import { useBankProfile } from '@contexts/BankProfileContext.tsx';
import { Loader } from '@gurupay/gp-ui-library';
import { useClassifiers } from '@hooks/useClassifiers.ts';
import { useTransactionDetail } from '@hooks/useTransactionDetail';
import { nullsToUndefined } from '@utils/utils';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';
import type { FXPayment } from 'types/operations';

import { FXFormContent } from './FXForm';

export const FXFormLoader = () => {
	const { id } = useParams();
	const { t } = useTranslation();
	const { selectedProfile } = useBankProfile();

	const { data: classifiers, isLoading: isClassifiersLoading } = useClassifiers();
	const {
		data: operation,
		isLoading: isOperationLoading,
		isError: isOperationError,
	} = useTransactionDetail(id ?? '');
	const { data: selectedAccount, isLoading: isAccountLoading } = useAccountDetails(
		operation?.account_uuid,
	);

	useEffect(() => {
		if (isOperationError) {
			toastError(t('payments.errors.notFound'));
		}
	}, [isOperationError, t]);

	if (isClassifiersLoading || (id && (isOperationLoading || isAccountLoading))) {
		return (
			<div className="flex items-center justify-center h-[500px]">
				<Loader />
			</div>
		);
	}

	if (id && selectedProfile && !isOperationLoading && !isAccountLoading && !operation) {
		return <Navigate replace to={'/operations'} />;
	}

	if (!classifiers) {
		return null;
	}

	return (
		<FXFormContent
			classifiers={classifiers}
			operation={nullsToUndefined(operation) as FXPayment | undefined}
			selectedAccount={selectedAccount}
		/>
	);
};
